import { render } from "./Erro404.vue?vue&type=template&id=7999b8e2"
import script from "./Erro404.vue?vue&type=script&lang=js"
export * from "./Erro404.vue?vue&type=script&lang=js"
script.render = render

export default script